import { createContext, useState } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const serverPort = 5050;
  const serverIP_Address = `http://localhost`;
  const base_URL = `${serverIP_Address}:${serverPort}`
  const [seriesList, setSeriesList] = useState([]);
  const [chillersList, setChillersList] = useState([]);
  const [selectedSeries, setSelectedSeries] = useState([]);
  const [inletTemp, setInletTemp] = useState('');  
  const [outletTemp, setOutletTemp] = useState('');  
  const [ambientTemp, setAmbientTemp] = useState('');  
  const [coolingCapacity, setCoolingCapacity] = useState(null);

  return (
    <AppContext.Provider value={{
        base_URL,
        seriesList, setSeriesList,
        chillersList, setChillersList,
        selectedSeries, setSelectedSeries,
        inletTemp, setInletTemp,
        outletTemp, setOutletTemp,
        ambientTemp, setAmbientTemp,
        coolingCapacity, setCoolingCapacity,
    }}>
        {children}
    </AppContext.Provider>);
};

export default AppContext;
